import React from 'react';
import { InputNumber } from 'antd';

export const MyInputNumber = ({ value, ...props }) => {
  const decimalSeparator = (1.1).toLocaleString().substring(1, 2);

  const customFormatter = (val) => {
    if (val || val === 0) {
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(val);
    }
    return '';
  };

  const customParser = (val) => {
    if (val || val === 0) {
      const cleaned = val.replace(/[^\d,-]/g, '').replace(/,/g, '.');
      let parsed =
        cleaned.includes('.') && cleaned.split('.')[1].length === 2
          ? parseFloat(cleaned).toFixed(2)
          : parseFloat(cleaned);
      const decimalIndex = val.indexOf(decimalSeparator);
      if (decimalIndex !== -1 && val.charAt(decimalIndex + 1) === '0') {
        parsed = parseFloat(parsed.toFixed(2));
      }
      return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  };

  const handleBlur = (e) => {
    e.target.value = customParser(e.target.value);
  };

  return (
    <InputNumber
      {...props}
      defaultValue={value}
      formatter={customFormatter}
      parser={customParser}
      onBlur={handleBlur}
    />
  );
};
